import { render, staticRenderFns } from "./WanXiangDetail.vue?vue&type=template&id=7671ff20&scoped=true&"
import script from "./WanXiangDetail.vue?vue&type=script&lang=js&"
export * from "./WanXiangDetail.vue?vue&type=script&lang=js&"
import style0 from "./WanXiangDetail.vue?vue&type=style&index=0&id=7671ff20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7671ff20",
  null
  
)

export default component.exports